import { render } from "./app-container-pending-payment-comments.vue?vue&type=template&id=35d15834"
import script from "./app-container-pending-payment-comments.vue?vue&type=script&lang=js"
export * from "./app-container-pending-payment-comments.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-container-pending-payment-comments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35d15834"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35d15834', __exports__)) {
    console.log('reload')
    api.reload('35d15834', __exports__)
  }
  
  module.hot.accept("./app-container-pending-payment-comments.vue?vue&type=template&id=35d15834", () => {
    console.log('re-render')
    api.rerender('35d15834', render)
  })

}


export default __exports__